window._define('models/NavigationPreference', function () { 'use strict';
    var version = 1,
        COOKIE_DISCLAIMER_TTL_IN_MONTH = 13;

    function NavigationPreference(conf) {
        if (!conf) {
            conf = {};
        }

        this.version = version;
        this.userId = conf.userId;
        this.consentCookieExpiredAt = conf.consentCookieExpiredAt || 0;
    }

    NavigationPreference.prototype.isCookieDisclaimerAccepted = function () {
        return this.consentCookieExpiredAt >= Date.now();
    };

    NavigationPreference.prototype.acceptCookieDisclaimer = function () {
        var expireDate = new Date();

        expireDate.setMonth(expireDate.getMonth() + COOKIE_DISCLAIMER_TTL_IN_MONTH);

        this.consentCookieExpiredAt = expireDate.getTime();
    };

    return NavigationPreference;
});
